import type { CreativeEditorInstance } from '..';
import { isTextBlock } from './block';

export function vectorizeText(editor: CreativeEditorInstance): number[] {
	if (!editor) return [];

	const { block, scene } = editor.engine;
	const page = scene.getCurrentPage();
	if (!page) return [];

	const width = block.getWidth(page);
	const height = block.getHeight(page);
	const x = block.getPositionX(page);
	const y = block.getPositionY(page);

	const content = block.getChildren(page);
	if (!content.length) return [];

	let unions: number[] = [];

	content.forEach(child => {
		const type = block.getType(child);
		if (isTextBlock(type)) {
			//Create a page sized rectangle
			const graphic = block.create('graphic');
			const rect = block.createShape('rect');
			block.setWidth(graphic, width);
			block.setHeight(graphic, height);
			block.setPositionX(graphic, x);
			block.setPositionY(graphic, y);
			block.setShape(graphic, rect);
			block.appendChild(page, graphic);

			const text = block.duplicate(child);
			block.appendChild(page, text);

			try {
				unions.push(block.combine([graphic, text], 'Intersection'));
				block.setVisible(child, false);
			} catch (e) {
				console.log(e);
				block.destroy(graphic);
				block.destroy(text);
			}
		}
	});

	return unions;
}

export function unVectorizeText(editor: CreativeEditorInstance, unions: number[]) {
	if (!editor) return;

	const { block, scene } = editor.engine;

	const page = scene.getCurrentPage();
	if (!page) return;

	const content = block.getChildren(page);
	if (!content.length) return;

	try {
		unions.forEach(union => {
			block.destroy(union);
		});
	} catch (e) {
		console.log(e);
	}

	content.forEach(child => {
		try {
			const type = block.getType(child);
			if (isTextBlock(type)) {
				block.setVisible(child, true);
			}
		} catch (e) {}
	});
}
